import { plainToClass } from "class-transformer";
import { AuditHistoryDialog } from '../../audit/scripts/audit-history.dialog';
import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";

export class AddressDialog implements IFilter {
    auditHistoryDialog: AuditHistoryDialog | null = null;
    addressTypes: any[];
    allSiteStudies: any[];
    assignTable: any;
    filterDropdownIds: string[];
    checkedSiteStudyIds: Set<number> = new Set();
    successCallback: (response: any) => void;
    siteId: number;
    siteName: string;

    constructor(allAddressTypesJson: any, allSitesJson: any, siteId: number, siteName: string, auditHistoryDialog?: AuditHistoryDialog) {
        $(() => {
            if (auditHistoryDialog) this.auditHistoryDialog = auditHistoryDialog;
            this.addressTypes = allAddressTypesJson.filter(t => t.Id !== 3); // Exclude type with ID 3...This is the AddressType for the Business Address which is for the one in the header and should not be used for site addresses
            this.allSiteStudies = allSitesJson.filter(ss => ss.SiteId === siteId); // Filter to current site
            this.siteId = siteId;
            this.siteName = siteName;
            
            this.filterDropdownIds = [
                '#address-assign-study-dropdown',
                '#address-assign-site-manager-dropdown'
            ];
            
            this.populateDialogDropdowns();
            this.initializeAssignFilters();
            this.initializeAssignTable();
            this.initializeCityStateDropdown();
            this.initializeConfirmedToggle();
            this.initializeSaveButton();
            
            $('#newAddressDialog').on('hidden.bs.modal', () => {
                this.checkedSiteStudyIds.clear();
                this.clearDialogFields();
                this.resetFilters();
                const validationError = document.getElementById('validation-error');
                validationError.classList.add('d-none');
            });
            if (this.auditHistoryDialog) {
                $('#newAddressDialog').on('click', '.ctms-icon-history[data-audit-field]', (evt) => {
                    const icon = $(evt.currentTarget);
                    const fieldName = icon.data('audit-field') as string;
                    const fieldLabel = icon.data('audit-label') as string;
                    const entityId = Number($('#addressId').val());
                    this.auditHistoryDialog.show('Address', entityId, fieldName, fieldLabel);
                });
            }
            $('#newAddressDialog').modal({
                backdrop: 'static',
                show: false,
            });
        });
    }

    populateDialogDropdowns(): void {
        const $typeDropdown = $('#addressType');
        $typeDropdown.empty();
        this.addressTypes.forEach(type => {
            $typeDropdown.append(`<option value="${type.Id}">${type.Name}</option>`);
        });
    }

    initializeCityStateDropdown(): void {
        const cityDropdown = $('#addressCityState');
        
        $(document).off('keyup.addresscitysearch');
        
        $(document).on('keyup.addresscitysearch', '#newAddressDialog .bs-searchbox input', async (event) => {
            const userInput = $(event.currentTarget).val()?.toString() || '';
            
            if (userInput.length < 2) {
                return;
            }
            
            try {
                const cityResponse = await fetch(
                    `/secure/ctms/sites/site-details?handler=CityStates&startsWith=${encodeURIComponent(userInput)}`,
                    {
                        method: 'GET'
                    }
                );
                
                if (!cityResponse.ok) throw new Error(cityResponse.statusText);
                
                const cityData = await cityResponse.json();
                
                cityDropdown.empty();
                
                cityData.forEach(item => {
                    cityDropdown.append(`<option value="${item.text}">${item.text}</option>`);
                });
                
                cityDropdown.selectpicker('refresh');
                
            } catch (err) {
                console.error('Failed to load city/state data', err);
            }
        });
    }

    initializeAssignFilters(): void {
        let studyValues: string[] = Unique(this.allSiteStudies.map(site => site.StudyName), true, ["None Selected"]);
        InitializeFilterDropdown('#address-assign-study-dropdown', studyValues, this);
        
        let siteManagerValues: string[] = [];
        this.allSiteStudies.forEach(site => { siteManagerValues.push(...site.UserNames); });
        siteManagerValues.push("Unassigned");
        siteManagerValues = Unique(siteManagerValues, true, ["None Selected"]);
        InitializeFilterDropdown('#address-assign-site-manager-dropdown', siteManagerValues, this);
        
        $('#address-assign-study-dropdown').on('change', () => this.triggerAssignTableFilter());
        $('#address-assign-site-manager-dropdown').on('change', () => this.triggerAssignTableFilter());
    }

    initializeAssignTable(): void {
        const self = this;
        this.assignTable = $('#address-assign-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[2, 'asc']],
            columns: [
                {
                    data: null,
                    title: '<input type="checkbox" id="address-assign-table-header-checkbox" />',
                    className: "ctms-table-col-check",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<input type="checkbox" class="assign-checkbox" data-id="${row.Id}" />`;
                    }
                },
                { data: "SiteName", title: "Site Name" },
                { data: "SiteNumber", title: "Site Number" },
                { data: "StudyName", title: "Study Name" },
                {
                    data: "UserNames",
                    title: "Site Manager",
                    render: function (data) {
                        return Array.isArray(data) ? data.join(", ") : "";
                    }
                }
            ],
            data: this.allSiteStudies
        });

        $('#address-assign-table-header-checkbox').on('change', function () {
            const isChecked = $(this).prop('checked');

            self.assignTable.rows({ search: 'applied' }).every(function () {
                const rowData = this.data();
                const $row = $(this.node());
                const $checkbox = $row.find('.assign-checkbox');

                if (isChecked) {
                    self.checkedSiteStudyIds.add(rowData.Id);
                    $checkbox.prop('checked', true);
                } else {
                    self.checkedSiteStudyIds.delete(rowData.Id);
                    $checkbox.prop('checked', false);
                }
            });

            self.updateHeaderCheckboxState();

            const isValid = self.checkedSiteStudyIds.size > 0;

            $('#validation-error-site-study-icon').toggleClass('d-none', isValid);
            $('#validation-error').toggleClass('d-none', isValid);
        });
        $('#address-assign-table tbody').on('change', '.assign-checkbox', function () {
            const id = Number($(this).attr('data-id'));

            if ($(this).prop('checked')) {
                self.checkedSiteStudyIds.add(id);
            } else {
                self.checkedSiteStudyIds.delete(id);
            }

            self.updateHeaderCheckboxState();
            const isValid = self.checkedSiteStudyIds.size > 0;

            $('#validation-error-site-study-icon').toggleClass('d-none', isValid);
            $('#validation-error').toggleClass('d-none', isValid);
        });

        this.assignTable.on('draw', function () {
            self.assignTable.rows().every(function () {
                const $row = $(this.node());
                const rowData = this.data();
                const $checkbox = $row.find('.assign-checkbox');
                if ($checkbox.length && self.checkedSiteStudyIds.has(rowData.Id)) {
                    $checkbox.prop('checked', true);
                } else {
                    $checkbox.prop('checked', false);
                }
            });
            self.updateHeaderCheckboxState();
        });

        this.assignTable.draw();

        $('#address-assign-search-input').on('input', function () {
            $('#address-assign-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('#address-assign-search-clear').on('click', function () {
            $('#address-assign-search-input').val('');
            $('#address-assign-table').DataTable().search('').draw();
        });

        $('#newAddressDialog').on('shown.bs.modal', () => {
            if (this.assignTable) {
                this.assignTable.columns.adjust();
            }
        });
    }

    initializeSaveButton(): void {
        $('#newAddressDialog .ctms-button-save').on('click', () => {
            if (this.checkedSiteStudyIds.size === 0) {
                $('#validation-error').removeClass('d-none');
                $('#validation-error-site-study-icon').removeClass('d-none');
                return;
            }

            const payload: any = {
                Id: $('#addressId').val(),
                AddressTypeId: $('#addressType').val(),
                Address: $('#addressField').val(),
                CityState: $('#addressCityState').val(),
                Notes: $('#addressNotes').val(),
                Confirmed: $('#addressConfirmed').prop('checked'),
                AssignedSiteStudies: this.getSelectedAssignedSiteStudies()
            };

            $('#newAddressDialog .ctms-button-save').prop('disabled', true);
            $('#addressSaveSpinner').show();
            $.ajax({
                url: '/secure/ctms/sites/site-details?handler=SaveAddress',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    ...payload
                }),
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() as string
                },
                success: (response) => {
                    $('#newAddressDialog').modal('hide');
                    this.successCallback(response);
                },
                error: (xhr) => {
                    alert('Error saving address.');
                },
                complete: () => {
                    $('#newAddressDialog .ctms-button-save').prop('disabled', false);
                    $('#addressSaveSpinner').hide();
                }
            });
        });
    }

    initializeConfirmedToggle(): void {
        const $confirmedCheckbox = $('#addressConfirmed');

        const toggleFields = () => {
            const isConfirmed = $confirmedCheckbox.prop('checked');

            $('#addressType').prop('disabled', isConfirmed);
            $('#addressField').prop('disabled', isConfirmed);
            $('#addressCityState').prop('disabled', isConfirmed);
            //$('#addressNotes').prop('disabled', isConfirmed);

           
            $('#addressCityState').selectpicker('refresh');
        };

        $confirmedCheckbox.on('change', toggleFields);

        toggleFields();
    }


    updateHeaderCheckboxState(): void {
        const $headerCheckbox = $('#address-assign-table-header-checkbox');
        const visibleRows: any[] = [];
        
        this.assignTable.rows({ search: 'applied' }).every(function () {
            visibleRows.push(this.data());
        });
        
        if (visibleRows.length === 0) {
            $headerCheckbox.prop('checked', false);
            $headerCheckbox.prop('indeterminate', false);
            return;
        }
        
        const checkedCount = visibleRows.filter(row => this.checkedSiteStudyIds.has(row.Id)).length;
        
        if (checkedCount === 0) {
            $headerCheckbox.prop('checked', false);
            $headerCheckbox.prop('indeterminate', false);
        } else if (checkedCount === visibleRows.length) {
            $headerCheckbox.prop('checked', true);
            $headerCheckbox.prop('indeterminate', false);
        } else {
            $headerCheckbox.prop('checked', false);
            $headerCheckbox.prop('indeterminate', true);
        }
    }

    getSelectedAssignedSiteStudies(): any[] {
        const checkedRows: any[] = [];
        this.allSiteStudies.forEach(site => {
            if (this.checkedSiteStudyIds.has(site.Id)) {
                checkedRows.push(site);
            }
        });
        return checkedRows.map(row => ({
            SiteStudyId: row.Id,
            SiteId: row.SiteId,
            SiteName: row.SiteName,
            StudyId: row.StudyId,
            StudyName: row.StudyName
        }));
    }

    clearDialogFields(): void {
        $('#addressId').val(0);
        $('#addressType').val('').trigger('change');
        $('#addressField').val('');
        $('#addressNotes').val('');
        $('#validation-error-site-study-icon').addClass('d-none');
        $('#validation-error').addClass('d-none');
        $('#addressConfirmed').prop('checked', false).trigger('change');
        
        // Clear city/state dropdown
        const $cityDropdown = $('#addressCityState');
        if ($cityDropdown.hasClass('selectpicker')) {
            $cityDropdown.selectpicker('destroy');
        }
        $cityDropdown.empty();
        $cityDropdown.selectpicker();
        $cityDropdown.addClass('selectpicker');
        $cityDropdown.selectpicker('refresh');
        
        this.checkedSiteStudyIds.clear();
    }

    populateDialogFieldsFromDto(dto: any): void {        
        $('#addressId').val(dto.Id);
        $('#addressType').val(dto.AddressTypeId).trigger('change');
        $('#addressField').val(dto.Address);
        $('#addressNotes').val(dto.Notes ?? dto.notes ?? '');
        $('#addressConfirmed').prop('checked', dto.Confirmed ?? dto.confirmed ?? false).trigger('change');
        
        const $cityDropdown = $('#addressCityState');
        
        // Destroy this to reinitialize later with the new value
        if ($cityDropdown.hasClass('selectpicker')) {
            $cityDropdown.selectpicker('destroy');
        }
        
        $cityDropdown.empty();
        if (dto.CityState) {
            $cityDropdown.append(`<option value="${dto.CityState}" selected>${dto.CityState}</option>`);
        }
        
        // Re-initialize the selectpicker
        $cityDropdown.selectpicker();
        $cityDropdown.addClass('selectpicker');
        $cityDropdown.selectpicker('refresh');

        // Populate assigned site studies
        if (this.assignTable && Array.isArray(dto.AssignedSiteStudies)) {
            this.checkedSiteStudyIds.clear();
            dto.AssignedSiteStudies.forEach((s: any) => {
                if (s.SiteStudyId !== undefined && s.SiteStudyId !== null) {
                    this.checkedSiteStudyIds.add(s.SiteStudyId);
                }
            });
            this.assignTable.draw(false);
        }
    }

    updateTable(matchingSites: any[]): void {
        this.assignTable.clear();
        this.assignTable.rows.add(matchingSites).draw();
    }

    triggerAssignTableFilter(): void {
        const study = $('#address-assign-study-dropdown').val() as string[];
        const siteManager = $('#address-assign-site-manager-dropdown').val() as string[];
        
        const filteredSites = this.allSiteStudies.filter((site) => {
            let studyMatch = study.includes(site.StudyName);
            
            let siteManagerMatch = true;
            let values: string[] = [];
            if (site.UserNames.length > 0) { values.push(...site.UserNames); }
            else { values.push("Unassigned"); }
            siteManagerMatch = siteManager.some(sm => values.includes(sm));
            
            return studyMatch && siteManagerMatch;
        });
        this.updateTable(filteredSites);
    }

    getSelectedDropdownValues(selectId: string): any {
        return $(selectId).val();
    }

    triggerFilter(): void {
    }

    resetFilters(): void {
        this.filterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $('#address-assign-search-input').val('');
        this.assignTable.search('').draw();
        this.updateTable(this.allSiteStudies);
    }
}

export class AddressDialogReadonly implements IFilter {
    addressTypes: any[];
    allSiteStudies: any[];
    assignedSites: any[];
    assignTable: any;
    filterDropdownIds: string[];
    successCallback: (response: any) => void;
    siteId: number;

    constructor(allAddressTypesJson: any, allSitesJson: any, siteId: number) {
        $(() => {
            this.addressTypes = allAddressTypesJson;
            this.allSiteStudies = allSitesJson.filter(ss => ss.SiteId === siteId);
            this.assignedSites = this.allSiteStudies;
            this.siteId = siteId;
            
            this.filterDropdownIds = [
                '#address-assign-study-dropdown',
                '#address-assign-site-manager-dropdown'
            ];
            
            this.populateDialogDropdowns();
            this.initializeAssignTable();
        });
    }

    populateDialogDropdowns(): void {
        $('#address-assign-study-dropdown').empty();
        $('#address-assign-site-manager-dropdown').empty();

        let studyValues: string[] = Unique(this.assignedSites.map(site => site.StudyName), true, ["None Selected"]);
        InitializeFilterDropdown('#address-assign-study-dropdown', studyValues, this);
        
        let siteManagerValues: string[] = [];
        this.assignedSites.forEach(site => { siteManagerValues.push(...site.UserNames); });
        siteManagerValues.push("Unassigned");
        siteManagerValues = Unique(siteManagerValues, true, ["None Selected"]);
        InitializeFilterDropdown('#address-assign-site-manager-dropdown', siteManagerValues, this);
        
        $('#address-assign-study-dropdown').on('change', () => this.triggerAssignTableFilter());
        $('#address-assign-site-manager-dropdown').on('change', () => this.triggerAssignTableFilter());
    }

    initializeAssignTable(): void {
        this.assignTable = $('#address-assign-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[0, 'asc']],
            columns: [
                { data: "SiteName", title: "Site Name" },
                { data: "SiteNumber", title: "Site Number" },
                { data: "StudyName", title: "Study Name" },
                {
                    data: "UserNames",
                    title: "Site Manager",
                    render: function (data) {
                        return Array.isArray(data) ? data.join(", ") : "";
                    }
                }
            ],
            data: this.allSiteStudies
        });

        $('#address-assign-search-input').on('input', function () {
            $('#address-assign-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('#address-assign-search-clear').on('click', function () {
            $('#address-assign-search-input').val('');
            $('#address-assign-table').DataTable().search('').draw();
        });

        $('#newAddressDialog').on('shown.bs.modal', () => {
            if (this.assignTable) {
                this.assignTable.columns.adjust();
            }
        });
    }

    updateTable(matchingSites: any[]): void {
        this.assignTable.clear();
        this.assignTable.rows.add(matchingSites).draw();
    }

    triggerAssignTableFilter(): void {
        const study = $('#address-assign-study-dropdown').val() as string[];
        const siteManager = $('#address-assign-site-manager-dropdown').val() as string[];
        
        const filteredSites = this.assignedSites.filter((site) => {
            let studyMatch = study.includes(site.StudyName);
            
            let siteManagerMatch = true;
            let values: string[] = [];
            if (site.UserNames.length > 0) { values.push(...site.UserNames); }
            else { values.push("Unassigned"); }
            siteManagerMatch = siteManager.some(sm => values.includes(sm));
            
            return studyMatch && siteManagerMatch;
        });
        this.updateTable(filteredSites);
    }

    getSelectedDropdownValues(selectId: string): any {
        return $(selectId).val();
    }

    populateDialogFieldsFromDto(dto: any): void {
        const typeObj = this.addressTypes.find(t => t.Id === dto.AddressTypeId);
        
        $('#addressId').val(dto.Id);
        $('#addressTypeReadonly').text(typeObj ? typeObj.Name : '');
        $('#addressFieldReadonly').text(dto.Address || '');
        $('#addressCityStateReadonly').text(dto.CityState || '');
        $('#addressNotesReadonly').text(dto.Notes ?? dto.notes ?? '');
        $('#addressConfirmedReadonly').text((dto.Confirmed ?? false) ? 'Yes' : 'No');


        if (this.assignTable && Array.isArray(dto.AssignedSiteStudies)) {
            const assignedIds = new Set(dto.AssignedSiteStudies.map((s: any) => s.SiteStudyId));
            this.assignedSites = this.allSiteStudies.filter(site => assignedIds.has(site.Id));
            this.updateTable(this.assignedSites);
            this.populateDialogDropdowns();
        }
    }

    triggerFilter(): void { }
    resetFilters(): void { }
    clearDialogFields(): void { }
}
